const LOGOUT_URL = '/signOut';

export function logout(): void {
	window.location.assign(LOGOUT_URL);
}
